import styled from 'styled-components';
import uniqueId from 'lodash/uniqueId';
import LinkList from '../../../molecules/LinkList';

const Block = styled.div`
  margin-top: 35px;
`;

const Headline = styled.h3`
  margin-top: 35px;
`;

/**
 * @param {MatrixItemProps} props
 * @returns {React.ReactElement} The rendered component
 */
const MatrixItem = ({ introText, blocks, isBrand }) => {
  return (
    <div>
      <div>{introText}</div>
      {blocks.map((block) => (
        <Block key={uniqueId('block_')}>
          <Headline>{block.headline}</Headline>
          <LinkList links={block.linkList} isBrand={isBrand} />
        </Block>
      ))}
    </div>
  );
};

export default MatrixItem;
